import { Record } from 'immutable';
import * as storageValidate from 'app/models/storage/validate';

export const SESSION_STORAGE_PREFIX = 'sessionStorage';

export const INIT = `${SESSION_STORAGE_PREFIX}/INIT`;
export const SET_ITEM = `${SESSION_STORAGE_PREFIX}/SET_ITEM`;
export const REMOVE_ITEM = `${SESSION_STORAGE_PREFIX}/REMOVE_ITEM`;

export const LAST_SYNCED_NAVIGATION_TIMESTAMP_MAP = 'LAST_SYNCED_NAVIGATION_TIMESTAMP_MAP';
export const LAST_SYNCED_LOCATION_KEY_MAP = 'LAST_SYNCED_LOCATION_KEY_MAP';

export const BEHIND_BROKEN_PROXY_ID = 'BEHIND_BROKEN_PROXY_ID';
export const SPLIT_PANE_SIZES = 'SPLIT_PANE_SIZES';
export const LOCALE_KEY = 'LOCALE_KEY';
export const DEVICE_MANAGER_STATE = 'DEVICE_MANAGER_STATE';

export const Storage = new Record({
  [LAST_SYNCED_NAVIGATION_TIMESTAMP_MAP]: null,
  [BEHIND_BROKEN_PROXY_ID]: null,
  [SPLIT_PANE_SIZES]: {},
  [LOCALE_KEY]: null,
  [DEVICE_MANAGER_STATE]: {},
})();

export const validateKey = storageValidate.validateKey(Storage);
